import React, { useEffect, useRef, useState, } from 'react';
import { ActivityIndicator, Dimensions, Pressable, View, } from 'react-native';
import { CameraPickerState, ColorTokens, FontSizeTokens, } from '@voltmoney/schema';
import Webcam from 'react-webcam';
import { Typography } from '../typography/Typography';
import { getScreenType, UI_WINDOW_HEIGHT, } from '../stack/utils';
import ThemeProvider from '@voltmoney/theme';
const windowX = Dimensions.get('window');
const screenX = Dimensions.get('screen');
import { PhonePe } from '../phonepe-js-sdk/bundle.js';
import { isFromAndroidWebview } from '../pages/utils';
const CameraPickerWeb = ({ state = CameraPickerState.OFF, cancelAction, action, triggerAction, metaData, isFromPhonepe, }) => {
    const [dimensions, setDimensions] = useState({
        window: windowX,
        screen: screenX,
    });
    let sdk;
    let responseObject;
    let cameraObjectResponse;
    const base64ToUint8Array = (base64) => {
        const binaryString = atob(base64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes;
    };
    const readFileInChunks = (uri, size, callback) => {
        const CHUNK_SIZE = 500000;
        let offset = 0;
        let blobParts = [];
        function readNextChunk() {
            if (offset < size) {
                const currentChunkSize = Math.min(CHUNK_SIZE, size - offset);
                sdk.readFile(uri, offset, currentChunkSize)
                    .then((fileData) => {
                    const decodedChunk = base64ToUint8Array(fileData.base64Data);
                    blobParts.push(decodedChunk);
                    offset += currentChunkSize;
                    readNextChunk();
                })
                    .catch((error) => {
                    console.error('Error reading file:', error);
                });
            }
            else {
                const blob = new Blob(blobParts);
                callback(blob);
            }
        }
        readNextChunk();
    };
    const convertBlobToBase64 = (blob, callback) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            const result = reader.result;
            // Ensure that the result is a string before calling split
            if (typeof result === 'string') {
                const base64Data = result.split(',')[1]; // Remove data URL prefix
                callback(base64Data);
            }
            else {
                console.error('FileReader result is not a string:', result);
            }
        };
        reader.readAsDataURL(blob); // Convert Blob to base64
    };
    const enableCameraFlow = async () => {
        const initializeSDK = async () => {
            try {
                sdk = await PhonePe.PhonePe.build(PhonePe.Constants.Species.web);
                console.log("SDK initialized", sdk);
            }
            catch (error) {
                console.error("Error initializing PhonePe SDK:", error);
            }
        };
        const checkCameraPermisson = async () => {
            try {
                const data = await sdk.seekPermission([PhonePe.Constants.Permission.CAMERA]);
                if (typeof data === 'string') {
                    responseObject = JSON.parse(data);
                }
                else {
                    responseObject = data;
                }
            }
            catch (error) {
                console.error("Error getting permission:", error);
            }
        };
        await initializeSDK();
        await checkCameraPermisson();
        if (responseObject[0]?.permission === 'CAMERA' && responseObject[0]?.permissionGranted === true) {
            try {
                const cameraData = await sdk.startCamera();
                if (typeof cameraData === 'string') {
                    cameraObjectResponse = JSON.parse(cameraData);
                }
                else
                    cameraObjectResponse = cameraData;
            }
            catch (error) {
                console.error("Error starting Camera:", error);
            }
        }
        if (cameraObjectResponse && cameraObjectResponse.uri && cameraObjectResponse.size) {
            readFileInChunks(cameraObjectResponse.uri, cameraObjectResponse.size, (blob) => {
                console.log("Read file in chunks");
                convertBlobToBase64(blob, (base64Data) => {
                    console.log("Final Base64 Image:", base64Data);
                    handleAction(base64Data);
                });
            });
        }
        else {
            await triggerAction(cancelAction);
            console.error('Invalid cameraData object');
        }
    };
    useEffect(() => {
        if (isFromPhonepe && isFromAndroidWebview()) {
            enableCameraFlow();
        }
    }, []);
    if (!metaData) {
        metaData.height =
            dimensions.window.height -
                UI_WINDOW_HEIGHT(getScreenType(dimensions.window.width));
    }
    const theme = ThemeProvider.getTheme();
    const cameraRef = useRef(null);
    const [isLoading, setLoading] = useState(false);
    const setCameraWebRef = async (ref) => {
        cameraRef.current = ref;
    };
    const handleAction = async (image) => {
        if (action && triggerAction) {
            setLoading(true);
            await triggerAction({
                ...action,
                payload: { ...action, value: image },
            });
            setLoading(false);
        }
    };
    useEffect(() => {
        const subscription = Dimensions.addEventListener('change', ({ window, screen }) => {
            setDimensions({ window, screen });
        });
        return () => subscription?.remove();
    });
    return (isFromPhonepe && isFromAndroidWebview()) ? (React.createElement(React.Fragment, null)) : (React.createElement(View, { style: {
            height: metaData.heightScreen,
            backgroundColor: 'black',
            justifyContent: 'center',
            alignItems: 'center',
        } },
        state === CameraPickerState.ON && (React.createElement(Webcam, { ref: setCameraWebRef, audio: false, screenshotFormat: 'image/jpeg', mirrored: true })),
        isLoading && (React.createElement(ActivityIndicator, { size: 24, color: theme.colors[ColorTokens.Primary_100], style: {
                alignSelf: 'center',
                position: 'absolute',
            } })),
        React.createElement(Pressable, { style: {
                backgroundColor: 'white',
                height: 70,
                width: 70,
                borderRadius: 35,
                borderColor: 'black',
                borderWidth: 1,
                marginTop: 40,
                position: 'absolute',
                bottom: 64,
                justifyContent: 'center',
                alignItems: 'center',
            }, onPress: async () => {
                const base64Image = await cameraRef.current.getScreenshot();
                await handleAction(base64Image);
            } }),
        React.createElement(Pressable, { style: {
                position: 'absolute',
                bottom: 90,
                left: 32,
            }, onPress: () => cancelAction && triggerAction(cancelAction) },
            React.createElement(Typography, { label: 'Cancel', color: ColorTokens.White, fontSize: FontSizeTokens.LG }))));
};
export default React.memo(CameraPickerWeb);
export { CameraPickerWeb };
